/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AzureUserError,
    AzureUserErrorFromJSON,
    AzureUserErrorToJSON,
} from '../models/AzureUserError';
import {
    type EndUserRequest,
    EndUserRequestFromJSON,
    EndUserRequestToJSON,
} from '../models/EndUserRequest';
import {
    type ExternalEndUserResponse,
    ExternalEndUserResponseFromJSON,
    ExternalEndUserResponseToJSON,
} from '../models/ExternalEndUserResponse';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';

export interface EndUserPostRequest {
    endUserRequest: EndUserRequest;
}

export interface UserIdPermissionsPermissionIdDeleteRequest {
    userId: string;
    permissionId: number;
}

export interface UserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequest {
    userId: string;
    permissionId: number;
    organizationId: number;
}

export interface UserIdRolesRoleIdDeleteRequest {
    userId: string;
    roleId: number;
}

export interface UserIdRolesRoleIdOrganizationOrganizationIdDeleteRequest {
    userId: string;
    roleId: number;
    organizationId: number;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * Creates request options for endUserPost without sending the request
     */
    async endUserPostRequestOpts(requestParameters: EndUserPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['endUserRequest'] == null) {
            throw new runtime.RequiredError(
                'endUserRequest',
                'Required parameter "endUserRequest" was null or undefined when calling endUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/end-user`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EndUserRequestToJSON(requestParameters['endUserRequest']),
        };
    }

    /**
     */
    async endUserPostRaw(requestParameters: EndUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalEndUserResponse>> {
        const requestOptions = await this.endUserPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalEndUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async endUserPost(requestParameters: EndUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalEndUserResponse> {
        const response = await this.endUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userIdPermissionsPermissionIdDelete without sending the request
     */
    async userIdPermissionsPermissionIdDeleteRequestOpts(requestParameters: UserIdPermissionsPermissionIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userIdPermissionsPermissionIdDelete().'
            );
        }

        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling userIdPermissionsPermissionIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{userId}/permissions/{permissionId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace('{permissionId}', encodeURIComponent(String(requestParameters['permissionId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async userIdPermissionsPermissionIdDeleteRaw(requestParameters: UserIdPermissionsPermissionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userIdPermissionsPermissionIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userIdPermissionsPermissionIdDelete(requestParameters: UserIdPermissionsPermissionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userIdPermissionsPermissionIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for userIdPermissionsPermissionIdOrganizationOrganizationIdDelete without sending the request
     */
    async userIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters: UserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userIdPermissionsPermissionIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling userIdPermissionsPermissionIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling userIdPermissionsPermissionIdOrganizationOrganizationIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{userId}/permissions/{permissionId}/organization/{organizationId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace('{permissionId}', encodeURIComponent(String(requestParameters['permissionId'])));
        urlPath = urlPath.replace('{organizationId}', encodeURIComponent(String(requestParameters['organizationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async userIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRaw(requestParameters: UserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userIdPermissionsPermissionIdOrganizationOrganizationIdDelete(requestParameters: UserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for userIdRolesRoleIdDelete without sending the request
     */
    async userIdRolesRoleIdDeleteRequestOpts(requestParameters: UserIdRolesRoleIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userIdRolesRoleIdDelete().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling userIdRolesRoleIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{userId}/roles/{roleId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async userIdRolesRoleIdDeleteRaw(requestParameters: UserIdRolesRoleIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userIdRolesRoleIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userIdRolesRoleIdDelete(requestParameters: UserIdRolesRoleIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userIdRolesRoleIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for userIdRolesRoleIdOrganizationOrganizationIdDelete without sending the request
     */
    async userIdRolesRoleIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters: UserIdRolesRoleIdOrganizationOrganizationIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userIdRolesRoleIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling userIdRolesRoleIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling userIdRolesRoleIdOrganizationOrganizationIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{userId}/roles/{roleId}/organization/{organizationId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));
        urlPath = urlPath.replace('{organizationId}', encodeURIComponent(String(requestParameters['organizationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async userIdRolesRoleIdOrganizationOrganizationIdDeleteRaw(requestParameters: UserIdRolesRoleIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userIdRolesRoleIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userIdRolesRoleIdOrganizationOrganizationIdDelete(requestParameters: UserIdRolesRoleIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userIdRolesRoleIdOrganizationOrganizationIdDeleteRaw(requestParameters, initOverrides);
    }

}
